import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { RouterEffects } from './router.effects';
import { RouterTrackingEffects } from './tracking/router-tracking.effects';

@NgModule({
  imports: [EffectsModule.forFeature([RouterEffects, RouterTrackingEffects])],
})
export class RouterStoreModule {}
